// extracted by mini-css-extract-plugin
export default {"modalWrapper":"ModalWrapper_modalWrapper__hca33"};